import { useLocalization } from "@fluent/react";
import { ContentCard } from "@narmi/design_system";
import { NeedBudgetIllustration } from "./NeedBudgetIllustration";
import { ReadyToGoIllustration } from "./ReadyToGoIllustration";
import styles from "./SelectedCar.module.css";

interface RefinanceLoanTypeSelectorProps {
  isRefinanceSelected: boolean | undefined;
  onClickPurchase: () => void;
  onClickRefinance: () => void;
}

function RefinanceLoanTypeSelector({
  isRefinanceSelected,
  onClickPurchase,
  onClickRefinance,
}: RefinanceLoanTypeSelectorProps) {
  const { l10n } = useLocalization();

  return (
    <div>
      <div className="fontSize--xs fontWeight--bold fontColor--secondary">
        {l10n.getString("auto-loan-selected-car-loan-type", null, "LOAN TYPE")}
      </div>
      <div className={styles.purchaseRefinanceOptionCards}>
        <ContentCard
          kind="toggle"
          onClick={onClickPurchase}
          radiusSize="l"
          isSelected={isRefinanceSelected === false}
        >
          <div className={styles.purchaseOptionContent}>
            <ReadyToGoIllustration />
            <div className="fontSize--m fontWeight--bold">
              {l10n.getString("auto-loan-selected-car-purchase-button", null, "Purchase")}
            </div>
          </div>
        </ContentCard>
        <ContentCard
          kind="toggle"
          onClick={onClickRefinance}
          radiusSize="l"
          isSelected={isRefinanceSelected === true}
        >
          <div className={styles.purchaseOptionContent}>
            <NeedBudgetIllustration />
            <div className="fontSize--m fontWeight--bold">
              {l10n.getString("auto-loan-selected-car-refinance-button", null, "Refinance")}
            </div>
          </div>
        </ContentCard>
      </div>
    </div>
  );
}

export { RefinanceLoanTypeSelector };
